module.exports = __webpack_public_path__ + "static/media/member-photo-franklin-chua.03675260.png";